import { translate } from 'i18n/i18n'
import { captureFrontendError } from 'utils/captureFrontendError'

export const getTrapConsumableLabel = (trapConsumable: string): string => {
  switch (trapConsumable) {
    case 'lure':
      return translate.phrases.placeholder('Lure')

    case 'liner':
      return translate.phrases.placeholder('Liner')

    case 'coroplast':
      return translate.phrases.placeholder('Trap Body')

    case 'battery':
      return translate.phrases.placeholder('Battery')

    default: {
      captureFrontendError(new Error(`Trap consumable: "${trapConsumable}" has not been implemented`))

      return trapConsumable
    }
  }
}
